import { ref, computed, watch, type Ref } from 'vue'
import { Dispositif, DispositifLibelle, TypePermission } from '@/features/domaine/types/opco'
import type { IconName } from '@designSystem/fondation/icons/iconsList'

export const DROPDOWN_PERMS = ['CAPP', 'CPRO', 'PROA', 'AF'].map((key) => ({
  key: key as Dispositif,
  label: DispositifLibelle[key as Dispositif],
}))

export const PERM_TOGGLES: ReadonlyArray<{
  icon: Extract<IconName, 'tick-circle' | 'key-square' | 'bank'>
  label: Extract<TypePermission, 'Facture' | 'RIB' | 'Administration'>
  hoverMessages?: {
    actif?: string
    inactif?: string
  }
}> = [
  { icon: 'tick-circle', label: 'Facture' },
  { icon: 'tick-circle', label: 'RIB' },
  {
    icon: 'key-square',
    label: 'Administration',
    hoverMessages: { actif: 'Est un administrateur', inactif: "N'est pas un administrateur" },
  },
] as const

export function usePaginatedListState<TDto, TVm>(
  source: Ref<TDto[] | null | undefined>,
  mapToVm: (item: TDto) => TVm,
  options?: { nbPagesMax?: number },
) {
  const nbPagesMax = options?.nbPagesMax ?? 10
  const currentPage = ref(1)

  const nbPages = computed(() => Math.ceil((source.value?.length ?? 0) / nbPagesMax))

  const vmList = computed<TVm[]>(() => (source.value ?? []).map(mapToVm))

  const pageVMs = computed(() =>
    vmList.value.slice((currentPage.value - 1) * nbPagesMax, currentPage.value * nbPagesMax),
  )

  watch([nbPages, () => source.value?.length], () => {
    if (nbPages.value === 0) currentPage.value = 1
    else currentPage.value = Math.min(Math.max(1, currentPage.value), nbPages.value)
  })

  return {
    currentPage,
    nbPages,
    nbPagesMax,
    vmList,
    pageVMs,
    DROPDOWN_PERMS,
    PERM_TOGGLES,
  }
}
